"use client";
import * as Sentry from "@sentry/nextjs";
import { isCircuitOpenLikeError } from "@sajilni/resilience/errors";
import { useEffect } from "react";
import { Button } from "ui";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isCircuitOpen = isCircuitOpenLikeError(error);

  useEffect(() => {
    if (!isCircuitOpen) {
      Sentry.captureException(error);
    }
  }, [error, isCircuitOpen]);

  return (
    <html lang="en" className="h-full">
      <body className="min-h-screen bg-white">
        <main className="flex min-h-screen items-center justify-center px-6 lg:px-8">
          <div className="text-center">
            <h1 className="mt-4 text-3xl font-bold capitalize tracking-tight text-gray-900 sm:text-5xl">
              {isCircuitOpen
                ? "Service temporarily unavailable"
                : error?.message}
            </h1>
            <p className="mt-6 text-base leading-7 text-gray-600">
              {isCircuitOpen
                ? "One of our core services is recovering. Please try again shortly."
                : "Sorry, something went wrong!"}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Button
                variant="solid"
                buttonColor="primary"
                onClick={() => reset()}
              >
                Try again
              </Button>
              <Button asChild variant="ghost">
                <a href="#" className="text-sm font-semibold text-gray-900">
                  Contact support <span aria-hidden="true">&rarr;</span>
                </a>
              </Button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
